import { useQuery } from "@tanstack/react-query";
import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { useApi } from "../../shared/api/index";

export const useFetchSite = () => {
  const { fetchData } = useApi();
  const { organizationId, sport, dataId } = useParams();

  return useQuery({
    queryKey: ["sites", organizationId, dataId],
    queryFn: async () => {
      const result = await fetchData({
        url: `${sport}/o/${organizationId}/sites/${dataId}`,
      });
      return result?.data?.[0];
    },
    enabled: !!dataId,
  });
};

export const useFetchSites = (params = {}, enabled) => {
  const { fetchData } = useApi();
  const { organizationId, sport } = useParams();
  let URL = `${sport}/o/${organizationId}/sites`;
  if (!isEmpty(params)) {
    URL += `?${new URLSearchParams(params)?.toString()}`;
  }

  return useQuery({
    queryKey: ["sites", organizationId, JSON.stringify(params)],
    queryFn: async () => {
      const result = await fetchData({
        url: URL,
      });
      return result?.data || [];
    },
    enabled: !!enabled,
  });
};
